import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { PageDrawer } from "../PageDrawer";

interface IPageFilterConditionDrawerProps {
    open: boolean;
    children: ReactNode;
    onClose: () => void;
}

export const PageFilterConditionDrawer = (props: IPageFilterConditionDrawerProps) => (
    <PageDrawer open={props.open} title={Translations.FilterCondition} icon={<FilterAltOutlinedIcon />} onClose={props.onClose} >
        {props.children}
    </PageDrawer>
);
